import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import MuiThemeProvider from '@mui/material/styles/ThemeProvider';
import { jssPreset, StylesProvider } from '@mui/styles';
import OfflineIndicator from 'components/OfflineIndicator/OfflineIndicator';
import { create } from 'jss';
import rtl from 'jss-rtl';
// project imports
import NavigationScroll from 'layout/NavigationScroll';
import React from 'react';
import { useSelector } from 'react-redux';
import { cssTransition, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// routing
import Routes from 'routes';
import rtlPlugin from 'stylis-plugin-rtl';
// defaultTheme
import themes from 'themes';

// Create rtl cache
const cacheRtl = createCache({
	key: 'muirtl',
	stylisPlugins: [rtlPlugin as any],
	prepend: true,
});

// Configure JSS
const jss = create({
	plugins: [...jssPreset().plugins, rtl()],
});

const bounceToastTransition = cssTransition({
	enter: 'bounce-in-fwd',
	exit: 'bounce-out-bck',
});

const App = () => {
	const customization = useSelector((state: any) => state.customization);

	return (
		<CacheProvider value={cacheRtl}>
			<StyledEngineProvider injectFirst>
				<MuiThemeProvider theme={themes(customization)}>
					<StylesProvider jss={jss}>
						<ToastContainer
							position='top-center'
							// theme='colored'
							autoClose={2000}
							newestOnTop={false}
							transition={bounceToastTransition}
							closeOnClick
							rtl={false}
							pauseOnHover
						/>
						<CssBaseline />
						<OfflineIndicator />
						<NavigationScroll>
							<Routes />
						</NavigationScroll>
					</StylesProvider>
				</MuiThemeProvider>
			</StyledEngineProvider>
		</CacheProvider>
	);
};

export default App;
